import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  useMediaQuery,
  useTheme
} from '@mui/material';
import PreloaderComponent from '#component/preloader';
import { getUserApiKeys, createApiKey, deleteApiKey, resetApiKeyState } from '#action/user/api-key';
import { snackBarError } from '#action/fetch';
import MobileView from './mobile-view';
import DesktopView from './desktop-view';
import CreateApiKeyDialog from './create-api-key-dialog';
import DeleteConfirmationDialog from './delete-confirmation-dialog';

const ApiKeyManager = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const { apiKeys, loading, error } = useSelector(state => state.userApiKeys);
  const dispatch = useDispatch();

  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedKeyId, setSelectedKeyId] = useState(null);

  useEffect(() => {
    if (error) {
      dispatch(snackBarError(error));
    }
  }, [dispatch, error]);

  useEffect(() => () => {
    dispatch(resetApiKeyState());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getUserApiKeys());
  }, [dispatch]);

  const handleCreateApiKey = async data => dispatch(createApiKey(data));

  const handleDeleteClick = keyId => {
    setSelectedKeyId(keyId);
    setDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = async () => {
    if (selectedKeyId) {
      await dispatch(deleteApiKey(selectedKeyId));
      setDeleteDialogOpen(false);
      setSelectedKeyId(null);
    }
  };

  let displayLoader = false;
  let displayDesktopView = false;
  let displayMobileView = false;

  if (loading && apiKeys.length === 0) {
    displayLoader = true;
  } else if (isMobile) {
    displayMobileView = true;
  } else {
    displayDesktopView = true;
  }

  return (
    <>
      {displayLoader && <PreloaderComponent />}
      {displayDesktopView && (
        <DesktopView
          apiKeys={apiKeys}
          setCreateDialogOpen={setCreateDialogOpen}
          handleDeleteClick={handleDeleteClick}
        />
      )}
      {displayMobileView && (
        <MobileView
          apiKeys={apiKeys}
          setCreateDialogOpen={setCreateDialogOpen}
          handleDeleteClick={handleDeleteClick}
        />
      )}
      <CreateApiKeyDialog
        open={createDialogOpen}
        onClose={() => setCreateDialogOpen(false)}
        onSubmit={handleCreateApiKey}
      />
      <DeleteConfirmationDialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        onConfirm={handleDeleteConfirm}
      />
    </>
  );
};

export default ApiKeyManager;
